import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CotizacionesListar, PedidosListar } from "../../configuracion/apiUrls";
import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import AlertaStock from "../../paginas/empleados/AlertStock";
import AlertaCreditosVencidos from "../../paginas/empleados/AlertaCreditoVencidos";
import { AxiosPrivado } from "../axios/Axios";
import ModalCarritoCitas from "../contenedores/ModalCarritoCotizacion";
import ModalCarritoPedidos from "../contenedores/ModalCarritoPedidos";
import ModoOscuro from "./ModoOscuro";
import { toggleSidebar } from "./sidebarUtils";
import { Howler } from 'howler';
import useSound from 'use-sound';

const Header = () => {
  const navigate = useNavigate();
  const { carritoCotizacion = [], carritoPedidos = [], usuario } = useContextUsuario() || {};
  const [pedidosPendientes, setPedidosPendientes] = useState(0);
  const [cotizacionesPendientes, setCotizacionesPendientes] = useState(0);
  const [modalIsOpenCotizaciones, setModalIsOpenCotizaciones] = useState(false);
  const [modalIsOpenPedidos, setModalIsOpenPedidos] = useState(false);
  const [isCajaOpen, setIsCajaOpen] = useState(false);
  const { alertas = [], listaProductosBajoStock = [] } = useContextEmpleado() || {};
  const underStockCount = listaProductosBajoStock.length;
  const creditosVencidosCount = alertas.length;
  const [play] = useSound('/dist/mp3/notify-2-313758.mp3', {
    volume: 0.5,
  });

  const playNotify = async () => {
    try {
      if (Howler.ctx.state === 'suspended') {
        await Howler.ctx.resume();
      }
      play();
    } catch (error) {
      console.warn("No se pudo reproducir el sonido:", error);
    }
  };
/*
  useEffect(() => {
    let intervalId;
    if (usuario.tipo === "Empleado") {
      PedidosPendientes();
      CotizacionesPendientes();

      intervalId = setInterval(() => {
        PedidosPendientes();
        CotizacionesPendientes();
      }, 600000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [usuario.tipo]);
*/
  const PedidosPendientes = async () => {
    try {
      const response = await AxiosPrivado.get(PedidosListar);
      const pedidosFiltrados = response.data.filter(pedido => pedido.estado === "Pendiente");
      const nuevosPedidosPendientes = pedidosFiltrados.length;

      setPedidosPendientes(prevPedidosPendientes => {
        if (nuevosPedidosPendientes > prevPedidosPendientes) {
          playNotify();
        } else if (nuevosPedidosPendientes > 0 && prevPedidosPendientes === 0) {
          playNotify();
        }
        return nuevosPedidosPendientes;
      });
    } catch (error) {
      console.error("Error al obtener pedidos pendientes:", error);
    }
  };
/*
  const CotizacionesPendientes = async () => {
    try {
      const response = await AxiosPrivado.get(CotizacionesListar);
      const cotizacionesFiltrados = response.data.filter(cotizacion => cotizacion.estado === "Pendiente");
      setCotizacionesPendientes(cotizacionesFiltrados.length);
    } catch (error) {
      console.error("Error al obtener cotizaciones pendientes:", error);
    }
  };
*/
  return (
    <>
      <nav className="main-header navbar navbar-expand">
        <ul className="navbar-nav">
          <li className="nav-item d-flex align-items-center">
            <button
              type="button"
              className="btn btn-sm d-flex align-items-center justify-content-center me-2 text-white"
              data-widget="pushmenu"
              role="button"
              title="Abrir o cerrar menú"
              aria-label="Abrir o cerrar menú lateral"
              onClick={toggleSidebar}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "8px",
                fontSize: "1.2rem",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                color: "#ffffff",
              }}
            >
              <i className="fas fa-bars"></i>
            </button>
          </li>
          {usuario.tipo === "Cliente" && (
            <>
              <li className="nav-item d-none d-sm-inline-block">
                <Link to="/app/clientes/productos" className="nav-link">Productos</Link>
              </li>
            </>
          )}
        </ul>
        <ul className="navbar-nav ml-auto">

          {usuario.tipo === "Cliente" && (
            <>
              <li className="nav-item">
                <a className="nav-link d-flex align-items-center" onClick={() => setModalIsOpenCotizaciones(true)}>
                  <span className="badge badge-info navbar-badge">{carritoCotizacion.length}</span>
                  <i className="fas fa-file-invoice mx-1"></i>
                  <ModalCarritoCitas modalIsOpen={modalIsOpenCotizaciones} setModalIsOpen={setModalIsOpenCotizaciones} />
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link d-flex align-items-center" onClick={() => setModalIsOpenPedidos(true)}>
                  <span className="badge badge-info navbar-badge">{carritoPedidos.length}</span>
                  <i className="fas fa-shopping-cart mx-1"></i>
                  <ModalCarritoPedidos modalIsOpen={modalIsOpenPedidos} setModalIsOpen={setModalIsOpenPedidos} />
                </a>
              </li>
            </>
          )}
          {usuario.tipo === "Empleado" && (
            <>
              <li className="nav-item">
                <a className="nav-link d-flex align-items-center" onClick={() => navigate("/app/admin/cotizaciones/gestionar")}>
                  <span className="badge badge-danger navbar-badge">{cotizacionesPendientes}</span>
                  <i className="fas fa-calendar-check mx-1"></i>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link d-flex align-items-center" onClick={() => navigate("/app/admin/pedidos/gestionar")}>
                  <span className="badge badge-danger navbar-badge">{pedidosPendientes}</span>
                  <i className="fas fa-clipboard-list mx-1"></i>
                </a>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link" role="button" onClick={() => setIsCajaOpen(!isCajaOpen)}>
                  <i className="fas fa-cash-register" />
                </a>
                <div className={`dropdown-menu dropdown-menu-lg dropdown-menu-right ${isCajaOpen ? 'show' : ''}`}>
                  <a className="dropdown-item" href="/app/admin/cajeros/apertura">
                    <i className="fas fa-door-open me-2" /> Apertura Caja
                  </a>
                  <a className="dropdown-item" href="/app/admin/cajeros/cierre">
                    <i className="fas fa-door-closed me-2" /> Cierre Caja
                  </a>
                </div>
              </li>
              {underStockCount > 0 && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link d-flex align-items-center"
                    data-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-bell"></i>
                    <span className="badge badge-warning navbar-badge">{underStockCount}</span>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-2"
                    style={{
                      minWidth: "260px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    <span className="dropdown-item dropdown-header">{underStockCount} Productos Bajo Stock</span>
                    <div className="dropdown-divider"></div>
                    <AlertaStock />
                    <div className="dropdown-divider"></div>
                    <a href="/app/admin/productos/gestionar" className="dropdown-item dropdown-footer">Ver todos los productos</a>
                  </div>
                </li>
              )}
              {creditosVencidosCount > 0 && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link d-flex align-items-center"
                    data-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="fas fa-exclamation-circle"></i>
                    <span className="badge badge-danger navbar-badge">{creditosVencidosCount}</span>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-2"
                    style={{
                      minWidth: "700px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    <span className="dropdown-item dropdown-header">
                      {creditosVencidosCount} Créditos Vencidos
                    </span>
                    <div className="dropdown-divider"></div>
                    <AlertaCreditosVencidos />
                  </div>
                </li>
              )}
            </>
          )}
          <li className="nav-item">
            <a className="nav-link" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt"></i>
            </a>
          </li>
          <ModoOscuro />
        </ul>
      </nav>
    </>
  );
};

export default Header;
